import locale from '../locale/ku_KU';
export default locale;
